
import Vue, { PropType } from 'vue';
import OrderOverviewProductData from './OrderOverviewProductData/OrderOverviewProductData.vue';
import OrderOverviewProductDataArtworks from './OrderOverviewProductData/OrderOverviewProductDataArtworks.vue';
import ProductVariations from './ProductVariations/ProductVariations.vue';
import TotalPricing from './TotalPricing/TotalPricing.vue';
import {
  PdpChoicesSetterType,
  PriceDetailsSetterType,
} from '@/setters/typings';
import { CvLoading, CvInlineNotification } from '@carbon/vue';
import { ArtworkResult } from '@/components/w2pFileUploader';
import { AxiosError } from 'axios';
import { SupportedLangCodes } from '../../constants/languageCodes';
import { ProductPrintData } from '@midocean/webapps-shared-domain';

export default Vue.extend({
  components: {
    ProductVariations,
    TotalPricing,
    OrderOverviewProductData,
    OrderOverviewProductDataArtworks,
    CvLoading,
    CvInlineNotification,
  },
  props: {
    lang: {
      type: String as PropType<SupportedLangCodes>,
      required: false,
      default: 'en',
    },
    priceDetails: {
      type: Object as PropType<PriceDetailsSetterType>,
      required: true,
    },
    pdpChoices: {
      type: Object as PropType<PdpChoicesSetterType>,
      required: true,
    },
    productPrintData: {
      type: Object as PropType<ProductPrintData>,
      required: true,
    },
    uploadedFileData: {
      type: Array as PropType<ArtworkResult[]>,
      default: [],
    },
    isDetailLost: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    isLoadingSpinnerActive: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    selectedMethod: {
      type: String,
      required: true,
    },
    errors: {
      type: [] as PropType<AxiosError>,
      default: [],
    },
    isFullDesignWithArtworksPathEnabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      title: '',
      masterProductSku: '',
      productDescription: '',
      fileUrl: '',
    };
  },

  mounted() {
    if (this.selectedMethod === 'Logo only') {
      this.title = this.$t(
        'flow-starter.product-data.title.uploaded-logo'
      ).toString();

      // ToDo: This will be set by the productImage from the pdpChoices object
      this.fileUrl = `data:image/png;base64, ${this.uploadedFileData[0].pngFile}`;
    } else {
      this.title = this.$t(
        'flow-starter.product-data.title.uploaded-file'
      ).toString();
      this.masterProductSku = this.pdpChoices.masterProductSKU;
      this.productDescription = this.pdpChoices.productDescription;

      const displayPositionId =
        this.productPrintData.productPrintPositions.find(
          (p) =>
            p.name ===
            this.pdpChoices.productPrintPositions[0].printPositionSAPCode
        )?.id as string;

      const displayVariantColor =
        this.pdpChoices.productVariants[0].variantColor;

      this.fileUrl = this.productPrintData.variants
        .find((v) => v.colour === displayVariantColor)
        ?.images.find((i) => i.printPositionID === displayPositionId)
        ?.imageUrl as string;
    }
  },

  methods: {
    generateNotificationSubTitle(): string {
      let printPositionsSubTitle = '';

      this.pdpChoices.productPrintPositions.forEach((p) => {
        printPositionsSubTitle = printPositionsSubTitle.concat(
          `${p.printPositionSAPCode}, `
        );
      });

      printPositionsSubTitle = printPositionsSubTitle.substring(
        0,
        printPositionsSubTitle.length - 2
      );

      return printPositionsSubTitle;
    },
  },
});
